<template>
  <el-container class="home-container">
    <!-- 头部区域 -->
    <el-header>
      <div>
        <img src="../assets/logo.png" alt />
        <span>东软云医院后台管理系统</span>
      </div>
      <el-button type="info" @click="logout">退出</el-button>
    </el-header>
    <!-- 页面主体区域 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <!-- 侧边栏菜单区域 -->
        <Menu/>
        <!-- 视光业务菜单（静态分组） -->
        <el-menu
          background-color="#333744"
          text-color="#fff"
          active-text-color="#409EFF"
          unique-opened
          :collapse="isCollapse"
          :collapse-transition="false"
          router
        >
          <el-submenu index="sg-customer">
            <template slot="title"><i class="el-icon-user"></i><span>客户管理</span></template>
            <el-menu-item index="/customer"><i class="el-icon-menu"></i><span>客户档案</span></el-menu-item>
          </el-submenu>
          <el-submenu index="sg-appointment">
            <template slot="title"><i class="el-icon-date"></i><span>预约分诊</span></template>
            <el-menu-item index="/appointment"><i class="el-icon-menu"></i><span>预约管理</span></el-menu-item>
            <el-menu-item index="/triage"><i class="el-icon-menu"></i><span>分诊管理</span></el-menu-item>
          </el-submenu>
          <el-submenu index="sg-optometry">
            <template slot="title"><i class="el-icon-view"></i><span>视光诊疗</span></template>
            <el-menu-item index="/optometry"><i class="el-icon-menu"></i><span>验光记录</span></el-menu-item>
            <el-menu-item index="/vision-function"><i class="el-icon-menu"></i><span>视功能检查</span></el-menu-item>
          </el-submenu>
          <el-submenu index="sg-fitting">
            <template slot="title"><i class="el-icon-box"></i><span>验配随访</span></template>
            <el-menu-item index="/lens-fitting"><i class="el-icon-menu"></i><span>OK镜RGP验配</span></el-menu-item>
            <el-menu-item index="/lens-followup"><i class="el-icon-menu"></i><span>随访记录</span></el-menu-item>
          </el-submenu>
          <el-submenu index="sg-prescription">
            <template slot="title"><i class="el-icon-tickets"></i><span>处方管理</span></template>
            <el-menu-item index="/prescription"><i class="el-icon-menu"></i><span>电子处方</span></el-menu-item>
          </el-submenu>
          <el-submenu index="sg-glasses">
            <template slot="title"><i class="el-icon-shopping-bag-2"></i><span>配镜业务</span></template>
            <el-menu-item index="/glasses-order"><i class="el-icon-menu"></i><span>配镜订单</span></el-menu-item>
            <el-menu-item index="/work-order"><i class="el-icon-menu"></i><span>加工工单</span></el-menu-item>
          </el-submenu>
          <el-submenu index="sg-stock">
            <template slot="title"><i class="el-icon-goods"></i><span>商品库存</span></template>
            <el-menu-item index="/product"><i class="el-icon-menu"></i><span>商品管理</span></el-menu-item>
            <el-menu-item index="/category"><i class="el-icon-menu"></i><span>商品分类</span></el-menu-item>
            <el-menu-item index="/supplier"><i class="el-icon-menu"></i><span>供应商</span></el-menu-item>
            <el-menu-item index="/stock"><i class="el-icon-menu"></i><span>库存与预警</span></el-menu-item>
            <el-menu-item index="/purchase"><i class="el-icon-menu"></i><span>采购管理</span></el-menu-item>
            <el-menu-item index="/stock-in"><i class="el-icon-menu"></i><span>入库单</span></el-menu-item>
            <el-menu-item index="/stock-out"><i class="el-icon-menu"></i><span>出库单</span></el-menu-item>
            <el-menu-item index="/stock-check"><i class="el-icon-menu"></i><span>库存盘点</span></el-menu-item>
          </el-submenu>
          <el-submenu index="sg-price">
            <template slot="title"><i class="el-icon-price-tag"></i><span>价格体系</span></template>
            <el-menu-item index="/price-system"><i class="el-icon-menu"></i><span>价格体系</span></el-menu-item>
          </el-submenu>
          <el-submenu index="sg-charge">
            <template slot="title"><i class="el-icon-wallet"></i><span>收费管理</span></template>
            <el-menu-item index="/charge"><i class="el-icon-menu"></i><span>收费开单</span></el-menu-item>
            <el-menu-item index="/sg-refund"><i class="el-icon-menu"></i><span>退费管理</span></el-menu-item>
            <el-menu-item index="/shift"><i class="el-icon-menu"></i><span>交班记录</span></el-menu-item>
            <el-menu-item index="/invoice"><i class="el-icon-menu"></i><span>发票管理</span></el-menu-item>
          </el-submenu>
          <el-submenu index="sg-member">
            <template slot="title"><i class="el-icon-star-on"></i><span>会员管理</span></template>
            <el-menu-item index="/member"><i class="el-icon-menu"></i><span>会员列表</span></el-menu-item>
            <el-menu-item index="/member-level"><i class="el-icon-menu"></i><span>会员等级</span></el-menu-item>
            <el-menu-item index="/recharge"><i class="el-icon-menu"></i><span>储值充值</span></el-menu-item>
            <el-menu-item index="/coupon"><i class="el-icon-menu"></i><span>优惠券</span></el-menu-item>
            <el-menu-item index="/member-coupon"><i class="el-icon-menu"></i><span>领券记录</span></el-menu-item>
            <el-menu-item index="/member-tag"><i class="el-icon-menu"></i><span>会员标签</span></el-menu-item>
          </el-submenu>
          <el-submenu index="sg-report">
            <template slot="title"><i class="el-icon-data-analysis"></i><span>报表中心</span></template>
            <el-menu-item index="/report-daily"><i class="el-icon-menu"></i><span>营业日报</span></el-menu-item>
            <el-menu-item index="/report-visits"><i class="el-icon-menu"></i><span>诊疗量统计</span></el-menu-item>
            <el-menu-item index="/report-inventory"><i class="el-icon-menu"></i><span>库存报表</span></el-menu-item>
            <el-menu-item index="/report-members"><i class="el-icon-menu"></i><span>会员分析</span></el-menu-item>
          </el-submenu>
          <el-submenu index="sg-import">
            <template slot="title"><i class="el-icon-upload2"></i><span>数据导入</span></template>
            <el-menu-item index="/import"><i class="el-icon-menu"></i><span>销售/验光数据导入</span></el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!-- 右侧内容主体 -->
      <el-main>
        <!-- 路由占位符 -->
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Menu from '../components/Menu.vue'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    Menu
  },
  methods: {
    logout () {
      window.sessionStorage.clear()
      this.$router.push('/login')
    }, // 退出登录
    ...mapActions([
      'toggleCollapse'
    ])
  },
  computed: {
    ...mapState({
      isCollapse: 'isCollapse'
    })
  }
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}
.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    img {
      height: 20px;
      width: 20px;
      margin-left: 20px;
    }
    span {
      margin-left: 15px;
    }
  }
}

.el-aside {
  background-color: #333744;
}

.el-main {
  background-color: #eaedf1;
}

.iconfont {
  margin-right: 10px;
}

.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}
</style>
